import React from 'react';
import PropTypes from 'prop-types';

import { Box, Link } from '@nerdwallet/currency';
import Image from '@nerdwallet/react-image';

import styles from './csrBoxLogo.module.less';

const CsrBoxLogo = ({
  imageUrl,
  imageAlt,
  imageHeight,
  imageWidth,
  linkUrl,
}) => (
  <Link href={linkUrl} className={styles.csrBoxLogo}>
    <Box>
      {imageUrl && (
        <Image
          src={imageUrl}
          alt={imageAlt}
          backgroundColor="transparent"
          naturalWidth={imageWidth}
          naturalHeight={imageHeight}
          className={styles.csrBoxLogoImage}
          lazy
        />
      )}
    </Box>
  </Link>
);

CsrBoxLogo.propTypes = {
  imageUrl: PropTypes.string,
  imageAlt: PropTypes.string,
  imageHeight: PropTypes.string,
  imageWidth: PropTypes.string,
  linkUrl: PropTypes.string,
};

CsrBoxLogo.displayName = 'CSR Box Logo Tile';

export default CsrBoxLogo;
